<template>
  <v-card class="maintenanceCard_card">
    <h2 class="maintenanceCard_title">ただいまメンテナンス中です</h2>
    <h3 class="maintenanceCard_caption">Sorry It's Under Maintenance</h3>
    <section class="maintenanceCard_img">
      <img src="@/assets/img/img_maintenance.svg" alt="maintenance" />
    </section>
    <section class="maintenanceCard_container">
      <p>
        現在メンテナンス中の為、表示できません。<br />
        ご不便をおかけしますが、完了までしばらくお待ちください。
      </p>
    </section>
  </v-card>
</template>

<script>
export default {
  name: 'MaintenanceCard',
};
</script>

<style lang="scss">
.maintenanceCard {
  &_card {
    width: 500px;
    height: 680px;
    overflow: hidden;
    margin: 0 auto;
    margin-bottom: 110px;
    &.v-sheet.v-card:not(.v-sheet--outlined) {
      padding: 102px;
      padding-top: 30px;
      box-shadow: 0 3px 12px 0 rgba(0, 0, 0, 0.06);
      background-color: #fff;
      border-radius: 10px;
    }
    .v-btn:not(.v-btn--round).v-size--large {
      height: 48px;
      border-radius: 10px;
    }

    .v-btn__content {
      font-weight: bold;
    }
    .theme--light.v-btn.v-btn--disabled.v-btn--has-bg {
      background-color: #eeeeee !important;
    }
  }
  &_title {
    font-size: 16px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.44;
    letter-spacing: normal;
    text-align: center;
    color: #333;
  }
  &_caption {
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.14;
    letter-spacing: normal;
    text-align: center;
    color: #666;
    margin-top: 10px;
  }

  &_container {
    display: flex;
    flex-direction: column;
    margin: 0 auto;
    p {
      font-size: 14px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.5;
      letter-spacing: normal;
      text-align: left;
      color: #666;

      display: inline;
    }
  }
  &_btn_container {
    text-align: center;
    margin-top: 28px;
  }
  &_error {
    &-wronginfo {
      height: 40px;
      font-size: 15px;
      font-weight: normal;
      line-height: 1.4;
      text-align: left;
      color: var(--error-color);
      margin: 0 auto;
      margin-top: 19px;
      margin-bottom: 27px;
    }
    &-gap {
      height: 30px;
    }
  }
  &_img {
    text-align: center;
    padding: 30px 0;
  }
  &_footer {
    margin: 0 auto;
    h5 {
      font-size: 14px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      letter-spacing: normal;
      text-align: left;
      color: #0075c2;
      cursor: pointer;
      margin-left: 18px;
    }
  }
}
</style>
